module.exports = __webpack_public_path__ + "static/media/youtube.34163239.svg";